import React from 'react';
import { motion } from 'framer-motion';
import './HeroSection.css';

const HeroSection = () => {
  return (
    <section className="demo-hero-section">
      <div className="container">
        <motion.div
          className="hero-badge"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          🎯 Elite Demo Member Exclusive
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          Keep Your <span>Elite Edge</span>.<br />Don't Trade Blind.
        </motion.h1>

        <motion.p
          className="hero-subtitle"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          You experienced 48 hours of live NSE data, orderflow analysis, and institutional tracking. 
          Now choose: Continue with Elite's precision, or Return to delayed data and guesswork.
        </motion.p>

        <motion.div
          className="promo-code-highlight"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6, delay: 0.3 }}
        >
          CODE: DEMO35
        </motion.div>

        <motion.p
          style={{ marginTop: '15px', fontSize: '16px', opacity: 0.9 }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 0.9 }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          35% OFF All Elite Plans + Exclusive Bonuses
        </motion.p>
      </div>
    </section>
  );
};

export default HeroSection;

